import {
  editImageCommonStyle,
  playPauseCarouselStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { panelStyle, previewHeaderStyle, previewContentStyle } from './preview-carousel-base-style';

const placementContainerStyle = {
  display: 'flex',
  position: 'relative',

  '&.disabled': {
    opacity: 0.5,
  },
};

export const getPreviewCarouselStyle = (_, theme) => ({
  ...playPauseCarouselStyle(theme),
  gridPreviewContainer: {
    ...editImageCommonStyle(),

    ...panelStyle,
    '& .placements-grid-preview-cell': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      ...previewHeaderStyle,
      ...previewContentStyle,
      '& .action-label': {
        textAlign: 'center',
        fontSize: 16,
        lineHeight: 2,
      },
    },
  },

  placementContainerRoot: {
    ...placementContainerStyle,

    // move the placement up a little bit to align with the original style
    '& > div:first-child': {
      top: '-5%',
    },
  },

  placementContainerRootGridView: {
    ...placementContainerStyle,
  },
});
